import type { Components, Theme } from '@mui/material';

export const MuiPaper: Components<Omit<Theme, 'components'>>['MuiPaper'] = {
  styleOverrides: {
    root: {
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0px 4px 9px 0px #00000024',
    },
  },
};
